import type { ContentsFilterInputType } from "@/types/graphql/partner.generated";

/**
 * Значения фильтра из querystring в `filter` списка видео, без `type`: его
 * добавляет список (`ContentTypeType.VideoType`), а в отчёте реестр.
 */
export function buildVideosFilter(
  filter: Record<string, unknown>
): ContentsFilterInputType {
  return {
    search: filter.search as string | undefined,
    tagIds: filter.tagIds as string[] | undefined,
    status: (filter.status as ContentsFilterInputType["status"]) || undefined,
    dateFrom: filter.dateFrom as string | undefined,
    dateTo: filter.dateTo as string | undefined,
    collectionIds: filter.collectionIds as string[] | undefined,
    productIds: filter.productIds as string[] | undefined,
  };
}
